import { render, staticRenderFns } from "./AddCarrierDia.vue?vue&type=template&id=2157ee59&scoped=true&"
import script from "./AddCarrierDia.vue?vue&type=script&lang=js&"
export * from "./AddCarrierDia.vue?vue&type=script&lang=js&"
import style0 from "./AddCarrierDia.vue?vue&type=style&index=0&id=2157ee59&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2157ee59",
  null
  
)

export default component.exports